/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  if(window.location.hash !== '') {
    var hash_item = document.querySelector(window.location.hash);
    if(hash_item && hash_item.classList.contains('accordion')) {
      var accordion_content = hash_item.querySelector('.accordion-content'),
          accordion_button;

      if(!hash_item.classList.contains('advanced')) {
        accordion_button = hash_item.querySelector('.accordion-title');
      } else {
        accordion_button = hash_item.querySelector('.accordion-toggle');
      }

      hash_item.classList.add('open');
      accordion_button.setAttribute('aria-expanded', 'true');
      accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
    }
  }

  var mobile_menu_trigger = document.querySelector('.mobile-menu-trigger');
  if(mobile_menu_trigger) {
    mobile_menu_trigger.addEventListener('click', function(e) {
      e.preventDefault();

      document.querySelector('body').classList.toggle('menu-open');
      document.querySelector('.menu-container').classList.remove('sub-menu-open');
    });
  }

  var mobile_sub_menu_trigger = document.querySelector('.menu-sub-trigger');
  if(mobile_sub_menu_trigger) {
    mobile_sub_menu_trigger.addEventListener('click', function(e) {
      e.preventDefault();

      mobile_sub_menu_trigger.parentNode.parentNode.classList.toggle('open');
    });
  }

  var cta_image_blocks = document.querySelectorAll('.cta-image-block');
  if(cta_image_blocks) {
    var block_movement_adjustment = 10;

    cta_image_blocks.forEach(function(cta_image_block) {
      var block_container = cta_image_block.querySelector('.cta-image-block-container'),
          block_container_height = block_container.offsetHeight,
          block_header = cta_image_block.querySelector('h4'),
          block_header_height = block_header.offsetHeight,
          block_movement = ((block_container_height - block_header_height) + block_movement_adjustment);

      block_container.style.transform = 'translateY(' + block_movement + 'px)';

      cta_image_block.addEventListener('mouseenter', function(e) {
        block_container.style.transform = 'translateY(0)';
      });

      cta_image_block.addEventListener('mouseleave', function(e) {
        block_container.style.transform = 'translateY(' + block_movement + 'px)';
      });
    });
  }

  // var accordion_triggers = document.querySelectorAll('.js-accordion');
  // if(accordion_triggers) {
  //   accordion_triggers.forEach(function(accordion_trigger) {
  //     if(accordion_trigger.hasAttribute('data-accordion-trigger')) {
  //       accordion_trigger = accordion_trigger.querySelector('.' + accordion_trigger.getAttribute('data-accordion-trigger'));
  //     }

  //     accordion_trigger.addEventListener('click', function(e) {
  //       e.preventDefault();

  //       var accordion_trigger = e.currentTarget;
  //       if(!accordion_trigger.classList.contains('js-accordion')) {
  //         accordion_trigger = accordion_trigger.parentNode;
  //       }

  //       if(accordion_trigger.classList.contains('open')) {
  //         history.replaceState({}, null, window.location.pathname);
  //         accordion_trigger.classList.remove('open');
  //       } else {
  //         if(accordion_trigger.hasAttribute('data-accordion-group')) {
  //           var accordion_group = accordion_trigger.getAttribute('data-accordion-group'),
  //               accordion_group_triggers = document.querySelectorAll('.js-accordion[data-accordion-group=' + accordion_group + ']');

  //           if(accordion_group_triggers) {
  //             Array.prototype.forEach.call(accordion_group_triggers, function(accordion_group_trigger) {
  //               accordion_group_trigger.classList.remove('open');
  //             });
  //           }
  //         }

  //         history.replaceState({}, null, window.location.pathname + '#' + accordion_trigger.getAttribute('id'));

  //         accordion_trigger.classList.add('open');
  //       }
  //     });
  //   });
  // }

  // var tertiary_items = document.querySelectorAll('.menu-tertiary > li');
  // if(tertiary_items) {
  //   tertiary_items.forEach(function(tertiary_item) {
  //     var tertiary_item_anchor = tertiary_item.querySelector('a:first-child'),
  //         tertiary_item_sub_items = tertiary_item.querySelectorAll('li');

  //     if(tertiary_item_sub_items.length === 1) {
  //       tertiary_item.classList.add('children-single');
  //     } else {
  //       tertiary_item.classList.add('children-multiple');
  //     }

  //     tertiary_item_anchor.addEventListener('click', function(e) {
  //       if(!this.parentNode.classList.contains('children-single')) {
  //         e.preventDefault();

  //         this.parentNode.classList.toggle('open');
  //       }
  //     });
  //   });
  // }

  // var menu_global_items = document.querySelectorAll('.menu-global > li');
  // if(menu_global_items) {
  //   menu_global_items.forEach(function(list_item) {
  //     list_item.addEventListener('focusin', function (e) {
  //       // NOTE: This cancels out a click for mobile when state chagnes
  //       if (Modernizr.mq('(min-width: 781px)')) {
  //         this.classList.add('hovered');
  //         this.dataset.focusin = Date.now();
  //       }
  //     });

  //     list_item.addEventListener('focusout', function (e) {
  //       // NOTE: This cancels out a click for mobile when state chagnes
  //       if (Modernizr.mq('(min-width: 781px)')) {
  //         this.classList.remove('hovered');
  //       }
  //     });
  //   });
  // }

  // var menu_global_container = document.querySelector('.menu-global-container');
  // if(menu_global_container) {
  //   var menu_list = menu_global_container.querySelector('.menu-global'),
  //       move_left = menu_global_container.querySelector('.move-left'),
  //       move_right = menu_global_container.querySelector('.move-right'),
  //       min_left = 40, // 40px button
  //       max_left = 0,
  //       movement_speed = 80;

  //   menu_global_container.style.height = menu_list.offsetHeight + 'px';

  //   window.addEventListener('resize', function() {
  //     menu_global_responsive();
  //   });

  //   move_left.addEventListener('click', function(e) {
  //     e.preventDefault();

  //     var next_left = parseInt(menu_list.style.left) - movement_speed,
  //         difference = (max_left - next_left) * -1;

  //     if(next_left <= max_left || difference <= (movement_speed / 2)) {
  //       next_left = max_left;
  //       menu_global_container.classList.remove('min-left');
  //       menu_global_container.classList.add('max-left');
  //     } else {
  //       menu_global_container.classList.remove('min-left');
  //       menu_global_container.classList.remove('max-left');
  //     }

  //     menu_list.style.left = next_left + 'px';
  //   });

  //   move_right.addEventListener('click', function(e) {
  //     e.preventDefault();

  //     var next_left = parseInt(menu_list.style.left) + movement_speed,
  //         difference = (next_left - min_left) * -1;

  //     if(next_left >= min_left || difference <= (movement_speed / 2)) {
  //       next_left = min_left;
  //       menu_global_container.classList.add('min-left');
  //       menu_global_container.classList.remove('max-left');
  //     } else {
  //       menu_global_container.classList.remove('min-left');
  //       menu_global_container.classList.remove('max-left');
  //     }

  //     menu_list.style.left = next_left + 'px';
  //   });

  //   menu_global_responsive();
  // }

  // function menu_global_responsive() {
  //   var menu_container_width = menu_global_container.offsetWidth,
  //       menu_list_items = menu_global_container.querySelectorAll('.menu-global > li'),
  //       menu_list_width = (menu_list_items.length - 1); // menu_list.offsetWidth;

  //   menu_list_items.forEach(function(menu_list_item) {
  //     menu_list_width = menu_list_width + menu_list_item.offsetWidth;
  //   });

  //   menu_global_container.style.height = menu_list.offsetHeight + 'px';
  //   max_left = ((menu_list_width - menu_container_width) + (min_left * 2)) * -1;

  //   // Check to see if the list is greater than the container.
  //   // Need to remove some from container so list isn't flush with the browser.
  //   if(menu_list_width > menu_container_width) {
  //     menu_global_container.classList.add('responsive');
  //     menu_global_container.classList.add('min-left');
  //     menu_list.style.left = min_left + 'px';
  //   } else {
  //     menu_global_container.classList.remove('responsive');
  //     menu_global_container.classList.remove('min-left');
  //     menu_global_container.classList.remove('max-left');
  //     menu_list.style.left = '50%';
  //   }
  // }

  // var scrollto_selectors = document.querySelectorAll('.js-scrollTo');
  // if (scrollto_selectors) {
  //   Array.prototype.forEach.call(scrollto_selectors, function (selector) {
  //     selector.addEventListener('click', function (e) {
  //       e.preventDefault();
  //
  //       var selector_id = selector.getAttribute('href');
  //       var scrollto_element = document.getElementById(selector_id.substring(1, selector_id.length));
  //       scrollto_element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //       history.pushState(null, null, selector_id);
  //     });
  //   });
  // }

  // var high_contrast_trigger = document.querySelector('#menu-footer-navigation a[href="#high_contrast"]');
  // if (high_contrast_trigger) {
  //   high_contrast_trigger.addEventListener('click', function (e) {
  //     e.preventDefault();

  //     var body = document.querySelector('body');

  //     // Check if already on high-contrast
  //     if(body.classList.contains('high-contrast')) {
  //       // Remove cookie
  //       document.cookie = 'tla_high_contrast=; Max-Age=-99999999; path=/';
  //     } else {
  //       // Set cookie that expires in 7 days
  //       var date = new Date();
  //       date.setTime(date.getTime() + (7*24*60*60*1000));
  //       document.cookie = 'tla_high_contrast=active; expires=' + date.toUTCString() + ';  path=/';
  //     }

  //     body.classList.toggle('high-contrast');
  //   });
  // }

  // var content_tables = document.querySelectorAll('table');
  // if (content_tables) {
  //   content_tables.forEach(function(content_table) {
  //     var content_table_parent = content_table.parentNode,
  //         wrapper = document.createElement('div');

  //     wrapper.classList.add('table-container');
  //     content_table_parent.insertBefore( wrapper, content_table );
  //     wrapper.appendChild(content_table);
  //   });
  // }

  // var anchor_targets = document.querySelectorAll('.js-anchor-target a');
  // if(anchor_targets) {
  //   anchor_targets.forEach(function(anchor_target) {
  //     anchor_target.setAttribute('target', '_blank');
  //   });
  // }

  // var alerts = document.querySelector('.alert-container');

  // if(alerts) {
  //   var close_alert = document.querySelector('.alert-close');

  //   close_alert.addEventListener('click', (e) => {
  //     e.preventDefault();

  //     document.cookie = 'TXLAAlerts=true; SameSite=lax; path=/';

  //     document.querySelector('.alert-container').remove();
  //   });
  // }

}());
